module.exports = __webpack_public_path__ + "bf2532df/img/attach-icon.2200b7fc.svg";